module.exports = __webpack_public_path__ + "static/media/0007.c3b7ed59.jpg";